import { useEffect, useState } from 'react'
import { serialScannerService } from '../services/SerialScannerService'

type UseSerialScannerProps = {
  onBarcodeScanned: (barcode: string) => void
}

export const useSerialScanner = ({ onBarcodeScanned }: UseSerialScannerProps) => {
  const [isSerialConnected, setIsSerialConnected] = useState<boolean>(serialScannerService.isConnected())

  // Connect to serial scanner on component mount
  useEffect(() => {
    if (serialScannerService.isSupported() && serialScannerService.isSerialConfigured()) {
      const isAlreadyConnected = serialScannerService.isConnected()
      if (!isAlreadyConnected) {
        serialScannerService.connect()
          .then(connected => {
            setIsSerialConnected(connected)
          })
      } else {
        setIsSerialConnected(true)
      }
    }
  }, [])

  // Set up barcode scanner callback when connection status changes
  useEffect(() => {
    if (isSerialConnected) {
      serialScannerService.setOnBarcodeScanned(onBarcodeScanned)
    }
  }, [isSerialConnected, onBarcodeScanned])

  return {
    isSerialConnected
  }
}
